// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/zugfeder-mit-ueberlagerter-oese/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteZugfederMitUeberlagerterOeseDE: PageEntry = {
  id: "example.produkte-zugfeder-mit-ueberlagerter-oese",
  locale: "de",
  slug: "produkte/zugfeder-mit-ueberlagerter-oese",
  seo: {
    title: "Zugfeder mit überlanger Öse | Dietz GmbH",
    description: "Umsetzung mit Sondermaschinen und speziellen Werkzeugvorrichtungen – Schloss- und Beschlagindustrie",
  },
  type: "post",
  h1: "Zugfeder mit überlanger Öse",
  intro: "Umsetzung mit Sondermaschinen und speziellen Werkzeugvorrichtungen – Schloss- und Beschlagindustrie",
  blocks: [
    { kind: "image", src: "/images/live/dtz-zugfeder-ueberlang.jpg", alt: "Zugfeder überlang", width: 1280, height: 1024 }
  ],
};
